export default __webpack_public_path__ + "static/media/tsight-cover.c2fdce54.jpg";